import React, { Component } from "react";
import ListBilling from "../components/ListBilling";

class Billings extends Component {
  render() {
    return (
      <div>
        <ListBilling />
      </div>
    );
  }
}

export default Billings;
